require.register("javascripts/dropdownMenu", function(exports, require, module){
  
var BlockView = require('views/block/base-block-view');
var InputCollectionView = require('views/block/input/input-collection-view');
var LocaleService = require('services/locale-service');
const FeedbackService = require('services/feedback-service');
const Feedback = require('models/feedback');
const LearnerProfile = require('services/learner-profile-service').default;

var FeedbackView = require('views/feedback/feedback-view');



(function () {
  class DropdownMenu {
    constructor() {
      this.collectionData = {};
      this.data = [];
      this.storage = window.sessionStorage;
    }

init(pageView, configs){
      

  const match1 = configs.parameters.feedbacks;

  var selectedOpt;
  var $option;
  
  function ConvertDropdown(select) {


    $(select).changeElementType("div");

    var $thisOpt = $(select).find("option");
    
    $thisOpt.wrapAll("<div class='dropdown_options' />");
    $thisOpt.each(function() {
      $option = $(this);

      $option.wrapAll("<div class='dropdown_opt' tabindex='0'/>");
      $option.parent().append("<div class='check'></div>");
      $option.changeElementType("data");
    });
    
    $(select).prepend("<span id='dropdown_menu_label' class='screen-reader-content'></span><div role='button' aria-haspopup='listbox' aria-labelledby='dropdown_menu_label' id='dropdown_menu_select' class='dropdown_select normal_border' tabindex='0'><p class='selected_text'></p><div class='dropdown_arrow'></div></div>");
    $("#dropdown_menu_label").text(LocaleService.t(configs.parameters.sr_text));
    
    var $selected = $(select).find("div[selected='selected']");
    var def = ($selected.length >= 1) ? $($selected) : $($(select).find(".dropdown_opt")[0]);
    $(select).find(".selected_text").prepend(def.text());
    $("#dropdown_menu").find(".dropdown_options").attr({ id:'dropdown_options', 'aria-labelledby':'dropdown_menu_label', 'tabindex':'-1'});
    $("#dropdown_menu").find(".dropdown_opt").attr({ role: 'option' });
    
    $(document).click(function() {
      $(".dropdown_options").slideUp(200);
      $(".dropdown_arrow").removeClass("active");
    })
 
    $(document).keypress(function() {
      $(".dropdown_options").slideUp(200);
      $(".dropdown_arrow").removeClass("active");
    })
    $(select).click(function(e) {
      e.stopPropagation();
      $option = $(this);
      $option.find(".dropdown_options").slideToggle(200);
      $option.find(".dropdown_arrow").toggleClass("active");
      $(".dropdown_select").toggleClass("active");
    })

    $(select).keypress(function(e) {
      e.stopPropagation();
      $option = $(this);
      $option.find(".dropdown_options").slideToggle(200);
      $option.find(".dropdown_arrow").toggleClass("active");
      $(".dropdown_select").toggleClass("active");
    })

    $(".dropdown_opt").click(function() {

      $(".hideclass").css('display', 'none');

      $option = $(this);
      $(".selected_text").contents()[0].nodeValue = $option.text();
      $option.parent().find(".dropdown_opt").removeAttr("selected");
      $option.attr("selected", "selected");
      $(".check").css("display", "none");
      $option.children(".check").css("display", "block");
      selectedOpt = $option.children().val();
      
      match1.forEach((element, i) => {
  
        if (match1[i].match.dropdown === selectedOpt){
          FeedbackService.renderFeedbackWithElementState(configs.parameters.feedbacks[i], $(configs.parameters.feedback_selector), "loaded", [ 'loaded' ], {});
        }

      });

    });

    $(".dropdown_opt").keypress(function() {

      $(".hideclass").css('display', 'none');

      $option = $(this);
      $(".selected_text").contents()[0].nodeValue = $option.text();
      $option.parent().find(".dropdown_opt").removeAttr("selected");
      $option.attr("selected", "selected");
      $(".check").css("display", "none");
      $option.children(".check").css("display", "block");
      selectedOpt = $option.children().val();
      
      match1.forEach((element, i) => {
  
        if (match1[i].match.dropdown === selectedOpt){
          FeedbackService.renderFeedbackWithElementState(configs.parameters.feedbacks[i], $(configs.parameters.feedback_selector), "loaded", [ 'loaded' ], {});
        }

      });

    });

    
  
  }
  (function($) {
      $.fn.changeElementType = function(newType) {
          var attrs = {};
  
          $.each(this[0].attributes, function(idx, attr) {
              attrs[attr.nodeName] = attr.nodeValue;
          });
  
          this.replaceWith(function() {
              return $("<" + newType + "/>", attrs).append($(this).contents());
          });
      };
  })(jQuery);
  
  ConvertDropdown("#dropdown_menu");
  
}

}
module.exports = DropdownMenu;
})();
  
});

